import React from 'react';
import PropTypes from 'prop-types';
import { MenuButton, ListItem } from 'react-md';
import { trackEvent } from '../../util/analytics';

const KebabMenu = ({ id, className, menuItems }) => (
  <MenuButton id={id} icon className={className} menuItems={menuItems}>
    more_vert
  </MenuButton>
);

KebabMenu.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  menuItems: PropTypes.array,
};

KebabMenu.defaultProps = {
  menuItems: [
    <ListItem
      key="contact-us-menu-item"
      primaryText="Contact us"
      onClick={() => {
        window.open('https://www.datatheorem.com/about/contact/', '_blank');
        trackEvent({
          category: 'External',
          action: 'Contact Us',
        })
      }}
    />,
  ],
};

export default KebabMenu;



// WEBPACK FOOTER //
// ./src/components/Header/KebabMenu.jsx